import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
function currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function detail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            console.log(`bakerysupplier/detail/${obj.vendor_id}`);
            const {
                data
            } = await axios.get(`bakerysupplier/detail/${obj.vendor_id}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kodevendor', 'namavendor', 'alamat', 'kota', 'bussinesgroup', 'contact'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/bakerysupplier${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'kodevendor', 'namavendor', 'alamat', 'kota', 'bussinesgroup', 'contact'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            let response = await axios({
                url: `/bakerysupplier/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Vendor_supplier_List.xlsx`);
            document.body.appendChild(link);
            link.click();
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.delete(`/bakerysupplier/${obj.vendor_id}`);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    })
}
function save(data) {
    return new Promise(async (resolve, reject) => {
        try {
            // delete data.materials;
            const resp = await axios.post('/bakerysupplier', data);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function taxgroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`/bakerysupplier/taxgroup`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

export default {
    currency, detail, list, exportxls, remove, save, taxgroup
};